import { CheckBox } from "@mui/icons-material";
import { FormCad } from "../../../components/viewCadastro/formCad";
import { ContasViewProps, mapDispatchToContasProps, mapStateToContasProps } from "../contas.controll";
import { useTransition } from "react";
import { canalDistController } from "../../canalDist/canalDist.controll";
import contasTab from "./contas.tab";
import { connect } from "react-redux";
import { Card, Toolbar } from "@mui/material";
import MeiopgSelect, { handleSetShowSelectMeioPagModal } from "../../meioPag/view/meiopg.select";



interface RecebimentoProps extends ContasViewProps {
    totalReceber?: number,

}
function Recebimento(props: RecebimentoProps) {
    const [transition, startTrasition] = useTransition()
    const { totalReceber, contasActions, contasState } = props

    const formValidate = (values: any) => {
        const errors: any = { meio_pag: {} }
        if (!values.valor)
            errors.valor = "Informe o valor"
        if (!values.meio_pag._id)
            errors.meio_pag.descricao = "Informe meio de pagamento"
        return errors
    }

    const handleMutator = ([value, field]: any, state: any, { changeValue }: any) => {
        changeValue(state, field, () => value)
    }


    const handleConfirmar = async (value: any) => {
        startTrasition(async () => {
            const respCanalDist = await canalDistController.getCanalDistAberto();
            if (respCanalDist.status === "ok") {
                let canal = respCanalDist.row!
                contasActions.receberPagamento({
                    canalDist: canal,
                    contasDetalhes: contasState.rows,
                    meioPag: value.meio_pag,
                    pessoaId: contasState.contaResumoSelected.key._id,
                    valor: value.valor
                })
            }
        })
    }

    return (
        <Card>
            <FormCad
                handleCancel={() => { }}
                handleOnSubmit={handleConfirmar}
                handleMutator={handleMutator}
                formValidation={formValidate}
                row={{ meio_pag: {}, valor: totalReceber }}

                contentForm={[
                    { fieldName: "valor", label: "Valor", type: "currency", key: "valor", colunsXS: 12, colunsSM: 12, colunsMD: 4, require: true },
                    {
                        fieldName: "meio_pag.descricao",
                        label: "Meio de Pagamento",
                        type: "select-dialog",
                        key: "descricao",
                        colunsXS: 12, colunsSM: 12, colunsMD: 8, require: true,
                        handleOnClickShow: () => handleSetShowSelectMeioPagModal(true),
                        ViewSelecionarDialog: (props => {
                            console.log("props ViewSelecionarDialog", props)
                            return (
                                <MeiopgSelect
                                    confirme={(value) => {
                                        props.handleMutator(value, "meio_pag")
                                        handleSetShowSelectMeioPagModal(false)
                                    }}
                                    valor={props.valuesForm.valor}
                                />

                            )
                        })
                    },
                ]}
                buttonActions={[
                    { variant: "contained", color: "success", label: "Confirmar Recebimento", type: "submit", icon: <CheckBox />, disabled: transition }
                ]}
                buttonInsider

            />
        </Card>
    )
}

export default connect(mapStateToContasProps, mapDispatchToContasProps)(Recebimento);